export const FETCH_OEMBED_REQUEST = 'oembed/REQUEST';
export const FETCH_OEMBED_SUCCESS = 'oembed/SUCCESS';
export const FETCH_OEMBED_FAILURE = 'oembed/FAILURE';

export const fetchOembedRequest = () => ({ type: FETCH_OEMBED_REQUEST });
export const fetchOembedSuccess = payload => ({ type: FETCH_OEMBED_SUCCESS, payload });
export const fetchOembedFailure = () => ({ type: FETCH_OEMBED_FAILURE });

export const fetchOembed = url => (dispatch, getState, { request }) => {
  dispatch(fetchOembedRequest());

  const promise = request(`/_api/oembed?url=${url}`);

  return promise
    .then(details => dispatch(fetchOembedSuccess(details)))
    .catch(() => dispatch(fetchOembedFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/fetch-oembed.js